var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 3h-9.75a.375.375 0 00-.375.375v5.25c0 .207.168.375.375.375h9.75a.375.375 0 00.375-.375v-5.25A.375.375 0 0010.875 3z",
    stroke: "#4E8278",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8.25 3l3 2.625M8.25 9l3-2.625M3.75 3l-3 2.625M3.75 9l-3-2.625",
    stroke: "#4E8278",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgMoney;